"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRadio = exports.HiddenRadio = exports.StyledLabelText = exports.StyledLabel = exports.StyledRadioGroup = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.StyledRadioGroup = styled_components_1.default.div `
  display: ${({ fullWidth }) => (fullWidth ? 'flex' : 'inline-flex')};

  ${({ inline }) => !inline &&
    (0, styled_components_1.css) `
      flex-direction: column;
    `}
`;
exports.StyledLabel = styled_components_1.default.label `
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.space.s050} 0;
  margin-right: ${({ theme }) => theme.space.s150};

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  ${({ reversed }) => reversed &&
    (0, styled_components_1.css) `
      flex-direction: row-reverse;
    `}
`;
exports.StyledLabelText = styled_components_1.default.span `
  flex: 1;

  color: ${({ theme }) => theme.colors.text.body};

  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.tinyText)};
`;
exports.HiddenRadio = styled_components_1.default.input.attrs(() => ({ type: 'radio' })) `
  position: absolute;

  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;

  cursor: inherit;
  opacity: 0;
`;
exports.StyledRadio = styled_components_1.default.span `
  display: flex;
  position: relative;
  align-items: center;
  cursor: pointer;

  &:before {
    content: '';

    display: block;

    box-sizing: border-box;
    width: 1.5rem;
    height: 1.5rem;
    border: 1px solid ${({ theme }) => theme.colors.gray.s300};

    background-color: ${({ theme }) => theme.colors.background.primary};

    border-radius: ${({ theme }) => theme.radius.s400};

    ${({ reversed }) => reversed
    ? (0, styled_components_1.css) `
            margin-left: 0.5rem;
          `
    : (0, styled_components_1.css) `
            margin-right: 0.5rem;
          `}
  }

  &:after {
    content: ${({ checked }) => (checked ? `''` : 'none')};

    position: absolute;
    top: 0.25rem;

    display: block;
    width: 1rem;
    height: 1rem;

    background-color: ${({ theme }) => theme.colors.main.base};

    border-radius: ${({ theme }) => theme.radius.s400};

    ${({ reversed }) => reversed
    ? (0, styled_components_1.css) `
            right: 0.25rem;
          `
    : (0, styled_components_1.css) `
            left: 0.25rem;
          `}
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    &:before {
      width: 1rem;
      height: 1rem;
    }

    &:after {
      width: 0.5rem;
      height: 0.5rem;
    }
  }

  ${({ disabled, theme }) => disabled &&
    (0, styled_components_1.css) `
      cursor: not-allowed;

      &:before {
        background-color: ${theme.colors.gray.s300};
      }

      &:after {
        background-color: ${theme.colors.gray.s400};
      }
    `}
`;
